import type { MessageKey } from './en-US';

export const ptBR: Record<MessageKey, string> = {
    'app.name': 'Tomato Pop',
    'app.support': 'Apoiar',
    'app.supportAria': 'Apoiar o Tomato Pop',
    'app.customize': 'Personalize seu tomate',
    'app.language': 'Idioma',
    'app.theme': 'Tema',
    'app.themeLight': 'Claro',
    'app.themeDark': 'Escuro',
    'app.themeSystem': 'Sistema',
    'app.themeDaytime': 'Automático (7h-19h)',
    'app.settings': 'Configurações',
    'settings.timer': 'Timer',
    'app.pullToRefresh': 'Puxe para baixo para atualizar',
    'app.backToTomato': '← Voltar ao tomate',
    'app.getOnMobile':
        'Leve seu tomate para qualquer lugar, com interações divertidas e um desbloqueio vitalício único e sem anúncios no seu dispositivo móvel.',

    'timer.focus': 'Foco',
    'timer.short_one': 'Só {minutes} minutinho',
    'timer.short_other': 'Só {minutes} minutinhos',
    'timer.long': 'Pausa longa',
    'timer.mode': 'Modo do timer',
    'timer.start': 'Iniciar',
    'timer.pause': 'Pausar',
    'timer.resume': 'Continuar',
    'timer.reset': 'Reiniciar',
    'timer.resetAria': 'Reiniciar o timer',
    'timer.skip': 'Pular',
    'timer.skipAria': 'Pular para o próximo',

    'page.today': '🍅 {count} hoje',
    'page.streak': '🔥 {count} dias seguidos',
    'page.listening': '🎧 Ouvindo',
    'page.plusOne': '+1 🍅',
    'page.breakOver': 'Fim da pausa!',

    'drawer.title': 'Deixe com a sua cara',
    'drawer.close': 'Fechar personalização',
    'drawer.glowColor': 'Cor do brilho',
    'drawer.glowMatch': 'Usar a cor do tomate',
    'drawer.tab.model': '🍅 Modelo',
    'drawer.tab.color': '🎨 Cor',
    'drawer.tab.face': '😎 Rosto',
    'drawer.tab.vines': '🌿 Folhas',
    'drawer.tab.scene': '🏞 Cenário',
    'drawer.tab.finish': '💥 Final',
    'drawer.tab.timer': '⏱ Timer',
    'drawer.useColor': 'Usar a cor {color}',
    'drawer.hex': 'Cor em hexadecimal',
    'drawer.model': 'Modelo base',
    'drawer.eyes': 'Olhos',
    'drawer.mouth': 'Boca',
    'drawer.hat': 'Chapéu',
    'drawer.necklace': 'Colar',
    'drawer.vine': 'Estilo das folhas',
    'drawer.scene': 'Cenário',
    'drawer.whenEnds': 'Quando o tempo acabar...',
    'drawer.try': 'Testar',
    'drawer.preview': 'Pré-visualizar {name}',
    'drawer.minutes': 'Minutos',
    'drawer.minutes.focus': 'Foco',
    'drawer.minutes.short': 'Curta',
    'drawer.minutes.long': 'Longa',
    'drawer.party': 'Modo festa: dançar com a música',
    'drawer.partyHint':
        'Ouve pelo microfone o que estiver tocando por perto. Nada é gravado nem enviado.',
    'drawer.partyFailed':
        'Não foi possível acessar o microfone. Permita o acesso nas configurações do navegador ou do celular e tente de novo.',
    'drawer.alarm': 'Som do alarme',
    'drawer.alarm.preview': 'Tocar o som do alarme',
    'drawer.alarm.classic': 'Bipes clássicos',
    'drawer.alarm.chime': 'Sinos',
    'drawer.alarm.bell': 'Sino',
    'drawer.alarm.gentle': 'Suave',
    'drawer.alarm.siren': 'Sirene',
    'drawer.alarm.system': 'Toque de alarme do celular',
    'drawer.alarm.hint':
        'Usado quando qualquer timer termina: foco, pausa ou roleta.',
    'drawer.lockScreen': 'Alarme em tela cheia na tela de bloqueio',
    'drawer.lockScreenHint':
        'Como um app de relógio: uma tela de alarme grande sobre a tela de bloqueio. Com o celular desbloqueado, você recebe uma notificação.',
    'drawer.alarmFix': 'Corrigir',
    'drawer.alarmProblem.notifications':
        'As notificações estão desativadas para o Tomato Pop, então a tela de alarme e seus botões não podem aparecer.',
    'drawer.alarmProblem.channel':
        'A categoria de notificação "Timer alarm" foi reduzida nas configurações do sistema, então o alarme não consegue ocupar a tela. Defina como urgente / aparecer na tela.',
    'drawer.alarmProblem.fullScreen':
        'O Android está bloqueando alarmes em tela cheia para este app. Permita "Notificações em tela cheia" para ver o tomate com o celular bloqueado.',
    'drawer.webNotify.denied':
        'As notificações estão bloqueadas para este site, então você não será avisado quando o timer terminar em uma aba em segundo plano. Permita nas configurações do site do navegador.',
    'drawer.webNotify.ask':
        'Permita notificações para ser avisado quando o timer terminar em uma aba em segundo plano.',
    'drawer.webNotify.enable': 'Permitir',
    'notify.startRest': 'Iniciar descanso',
    'notify.restart': 'Reiniciar',
    'notify.dismiss': 'OK',
    'drawer.sound': 'Efeitos sonoros',
    'drawer.developer': 'Desenvolvedor',
    'drawer.skipLast': 'Pular para os últimos 10 segundos',

    'opt.none': 'Nenhum',
    'opt.model.classic': 'Clássico',
    'opt.model.timer': 'Timer de cozinha',
    'opt.eyes.googly': 'Esbugalhados',
    'opt.eyes.angry': 'Bravo',
    'opt.eyes.shades': 'Óculos escuros',
    'opt.eyes.hearts': 'Corações',
    'opt.mouth.smile': 'Sorriso',
    'opt.mouth.tongue': 'Língua',
    'opt.mouth.mustache': 'Bigode',
    'opt.hat.party': 'Festa',
    'opt.hat.tophat': 'Cartola',
    'opt.hat.crown': 'Coroa',
    'opt.hat.wizard': 'Mago',
    'opt.neck.tshirt': 'Camiseta',
    'opt.neck.pearls': 'Pérolas',
    'opt.neck.bling': 'Ouro 2ma2',
    'opt.vine.classic': 'Clássico',
    'opt.vine.ivy': 'Hera',
    'opt.vine.blossom': 'Flor',
    'opt.bg.default': 'Brilho',
    'opt.bg.beach': 'Praia',
    'opt.bg.space': 'Espaço',
    'opt.bg.farm': 'Fazenda',
    'opt.done.explode': 'Explodir',
    'opt.done.explode.blurb': 'Splat! Pedaços e acessórios para todo lado.',
    'opt.done.roll': 'Sair rolando',
    'opt.done.roll.blurb':
        'Rola para fora da tela e um novo tomate entra rolando.',
    'opt.done.rocket': 'Foguete',
    'opt.done.rocket.blurb': 'Decola rumo à órbita.',

    'ads.advertisement': 'Publicidade',
    'ads.footerPreview': 'Prévia do anúncio do rodapé',
    'ads.breakTitle': 'Intervalo de anúncio · mantém o Tomato Pop grátis',
    'ads.breakPreview': 'Prévia do intervalo de anúncio',
    'ads.continue': 'Continuar',
    'ads.continueIn': 'Continuar em {seconds}s',
    'footer.about': 'Sobre',
    'footer.privacy': 'Privacidade',

    'support.title': 'Apoiar o Tomato Pop',
    'support.intro':
        'O Tomato Pop é um app pequeno e bobo feito por uma pessoa só. Os anúncios e o apoio o mantêm vivo e criando chapéus novos.',
    'support.owned':
        'Você tem acesso vitalício: sem anúncios, para sempre. Obrigado, você é uma lenda!',
    'support.lifetime': 'Remover anúncios para sempre · {price}',
    'support.lifetimeHint':
        'Um único pagamento, sem assinatura. Remove todos os anúncios de vez, nesta conta da loja.',
    'support.restore': 'Restaurar uma compra anterior',
    'support.coffee': '☕ Me pague um café',
    'support.pix': '🇧🇷 Pix (Mercado Pago)',
    'support.noLink':
        'O link de doação ainda não foi configurado (REACT_APP_DONATE_URL).',
    'support.noAds':
        'Quer ficar sem anúncios? O app de celular tem um desbloqueio vitalício único.',
    'support.noAccount':
        'Sem conta, sem cadastro. Seu tomate fica neste dispositivo.',
    'support.about': 'Sobre',
    'support.privacy': 'Política de privacidade',
    'support.close': 'Fechar',
    'goal.heading': 'Meta da comunidade: {item}',
    'goal.how': 'Quando o pote encher, todo mundo ganha, apoiando ou não.',
    'goal.progress': '{raised} de {target}',
    'goal.funded': 'Meta batida! Liberado para todo mundo 🎉',
    'goal.locked': 'Libera quando a meta for batida',
    'goal.ledger': 'De onde veio',
    'goal.empty': 'Nenhuma contribuição ainda. Seja o primeiro!',

    'about.title': 'Sobre o Tomato Pop',
    'about.intro':
        'O Tomato Pop é um timer pomodoro gratuito com personalidade. Você trabalha em sessões de foco e um tomate 3D faz companhia: ele amadurece e brilha conforme o tempo passa e, quando você termina, comemora do jeito que você escolher. Vista-o, escolha a cor e deixe o foco um pouco mais divertido.',
    'about.whatTitle': 'O que é a técnica pomodoro?',
    'about.what1':
        'A técnica pomodoro foi criada por Francesco Cirillo no fim dos anos 1980 e leva o nome do timer de cozinha em forma de tomate que ele usava na faculdade. A ideia é simples: escolha uma tarefa, trabalhe nela com atenção total por 25 minutos e faça uma pausa curta. Depois de quatro sessões, faça uma pausa mais longa. Os intervalos curtos e fixos facilitam começar, protegem você das distrações e criam um ritmo constante de pequenas vitórias.',
    'about.what2':
        'O Tomato Pop segue o padrão clássico por padrão: 25 minutos de foco, 5 minutos de pausa curta e 15 minutos de pausa longa a cada quatro sessões de foco. Você pode mudar os três tempos no painel de personalização.',
    'about.customTitle': 'O que você pode personalizar',
    'about.custom1':
        'A cor do tomate, com um seletor de cores ou amostras prontas.',
    'about.custom2':
        'Olhos (esbugalhados, bravos, óculos escuros, corações), boca (sorriso, língua, bigode), chapéu (de festa, cartola, coroa) e colar (camiseta, pérolas, ouro).',
    'about.custom3':
        'Um estilo de folhas (clássico, hera ou flor) e um cenário (praia, espaço ou fazenda).',
    'about.custom4':
        'Como ele comemora quando uma sessão termina: pode explodir, sair rolando ou decolar como um foguete, cada um com seus sons.',
    'about.custom5':
        'Tempos do timer, efeitos sonoros e um modo festa que dança com a música.',
    'about.tipsTitle': 'Dicas para sessões de foco melhores',
    'about.tip1':
        'Decida no que vai trabalhar antes de apertar iniciar e anote.',
    'about.tip2':
        'Silencie as notificações e deixe o celular longe durante os 25 minutos.',
    'about.tip3':
        'Se uma distração surgir, anote no papel e volte para a tarefa.',
    'about.tip4':
        'Faça a pausa de verdade: levante, alongue, beba água e tire os olhos da tela.',
    'about.tip5':
        'Divida tarefas grandes em partes que caibam em uma ou duas sessões.',
    'about.faqTitle': 'Perguntas',
    'about.q1': 'Preciso de uma conta?',
    'about.a1':
        'Não. O Tomato Pop não tem contas nem cadastro. Seu tomate, suas configurações e a contagem diária ficam apenas no seu dispositivo.',
    'about.q2': 'Continua funcionando em uma aba em segundo plano?',
    'about.a2':
        'Sim. O timer segue o relógio real, então continua preciso mesmo que o navegador deixe a aba em segundo plano mais lenta.',
    'about.q3': 'Por que há anúncios?',
    'about.a3':
        'O Tomato Pop é feito por uma pessoa e é gratuito. Os anúncios e o apoio dos usuários o mantêm no ar. O app de celular tem um desbloqueio vitalício único que remove todos os anúncios.',
    'about.q4': 'Como posso apoiar?',
    'about.a4a': 'Use o botão Apoiar no topo da página. Veja nossa',
    'about.a4link': 'política de privacidade',
    'about.a4b': 'para saber como dados e anúncios são tratados.',
    'about.q5': 'Como entro em contato?',
    'about.a5': 'Escreva para',
    'app.getOnMobileButton': 'Leve no celular',
    'app.getOnMobileTitle': 'Leve o Tomate no seu celular',
    'app.close': 'Fechar',
    'store.googlePlay': 'Disponível no Google Play',
    'store.appStore': 'Baixe na App Store',
    'store.comingSoon': 'Em breve',
    'store.comingSoonGooglePlay': 'Em breve no Google Play',
    'store.comingSoonAppStore': 'Em breve na App Store',
    'scene.farmSign': 'FAZENDA DE TOMATE',
    'privacy.consent':
        'Na União Europeia, no Reino Unido e na Suíça pedimos o seu consentimento antes de mostrar anúncios, por meio do formulário de consentimento do Google, no app Android e no site. Você pode mudar sua escolha a qualquer momento: no app Android, pelo botão abaixo; no site, pelo botão de configurações de privacidade que o Google exibe.',
    'privacy.adChoices': 'Escolhas de privacidade de anúncios',
    'privacy.title': 'Política de Privacidade',
    'privacy.intro':
        'O Tomato Pop é um app pequeno que respeita a sua privacidade. Esta política explica o que é guardado, o que é compartilhado e por quê. Ao usar o Tomato Pop você concorda com ela.',
    'privacy.deviceTitle': 'O que fica no seu dispositivo',
    'privacy.p1':
        'O Tomato Pop não tem contas nem servidor próprio. Seu tomate, suas configurações, o idioma e as estatísticas do dia ficam apenas no seu dispositivo e nunca são enviados para nós.',
    'privacy.adsTitle': 'Publicidade',
    'privacy.p2a':
        'O app gratuito mostra anúncios do Google (AdSense na web, AdMob no app de celular). O Google e seus parceiros podem usar cookies ou identificadores do dispositivo para exibir e medir anúncios, inclusive anúncios personalizados quando você consente ou a lei permite. Você pode gerenciar isso nas suas',
    'privacy.googleSettings': 'configurações de anúncios do Google',
    'privacy.p2b':
        ', e saber como o Google usa dados de sites que usam seus serviços em',
    'privacy.p3':
        'O desbloqueio vitalício único no app de celular remove todos os anúncios.',
    'privacy.micTitle': 'Microfone (modo festa)',
    'privacy.mic':
        'O modo festa é opcional e vem desligado. Ao ligá-lo, o navegador ou o celular pede acesso ao microfone para o tomate ouvir a música por perto. O som é analisado no seu dispositivo para encontrar a batida e nunca é gravado, guardado nem enviado a lugar nenhum. Você pode desligar quando quiser.',
    'privacy.purchasesTitle': 'Compras',
    'privacy.purchases':
        'As compras e o link opcional de apoio são tratados pela Apple, pelo Google ou pelo serviço de apoio que você escolher. Nunca vemos seus dados de pagamento.',
    'privacy.ageTitle': 'Idade',
    'privacy.age':
        'O Tomato Pop é adequado para todas as idades. Ele não coleta intencionalmente informações pessoais de ninguém, inclusive crianças.',
    'privacy.changesTitle': 'Mudanças nesta política',
    'privacy.changes':
        'Podemos atualizar esta política de tempos em tempos. A data abaixo mostra a versão mais recente.',
    'privacy.contactTitle': 'Fale conosco',
    'privacy.contact': 'Se tiver dúvidas sobre esta política, escreva para',
    'privacy.updated': 'Última atualização: {date}',
    'timer.roulette': 'Cochileta Russa',
    'timer.unknownClock': '??:??',
    'page.rouletteBoom': 'Acordou! 💥',
    'notify.focus': 'Sessão de foco concluída! Hora de uma pausa 🍅',
    'notify.break': 'A pausa acabou. Pronto para a próxima?',
    'notify.running': 'Timer em andamento – termina às {time}',
    'notify.cancel': 'Cancelar',
    'notify.roulette': 'Acordou! 💥',
    'drawer.roulette': 'Cochileta Russa: toca em um momento aleatório',
    'drawer.minutes.rouletteMin': 'No mínimo',
    'drawer.minutes.rouletteMax': 'No máximo',
    'page.streakNone': '🔥 Comece uma sequência',
    'streak.title': 'Sequência diária',
    'streak.close': 'Fechar',
    'streak.days': '{count} dias seguidos',
    'streak.status.none':
        'Ainda sem sequência. Conclua uma sessão de foco para acender a chama.',
    'streak.status.done': 'Por hoje está feito. Sua sequência está segura 🔥',
    'streak.status.open':
        'Conclua uma sessão de foco hoje para manter a sequência.',
    'streak.status.rest':
        'É fim de semana: descanse. Sua sequência está segura 😴',
    'streak.how.title': 'Como funciona',
    'streak.how.1':
        'Conclua pelo menos uma sessão de foco no dia e a sequência cresce em um.',
    'streak.how.2':
        'Fim de semana é para descansar. Sábados e domingos nunca quebram a sequência, e uma sessão neles ainda conta.',
    'streak.how.3': 'Se pular um dia útil, a sequência recomeça.',
    'streak.popup': '🔥 {count} dias!',
    'streak.gift.title': '🍀 Que sorte!',
    'streak.gift.body':
        'Sua sequência de {count} dias escapou, mas os deuses do tomate estão generosos hoje. Assista a um vídeo rápido e ela volta na hora.',
    'streak.gift.accept': 'Trazer de volta',
    'streak.gift.decline': 'Deixar pra lá',
    'streak.gift.retry':
        'O vídeo foi fechado antes do fim. Tente de novo para recuperar a sequência.',
    'streak.gift.back': '🔥 A sequência de {count} dias voltou!',
    'drawer.streakReminders': 'Lembretes da sequência',
    'drawer.streakRemindersHint':
        'Um empurrãozinho nas noites de dia útil para manter a sequência. Nunca no fim de semana.',
    'streak.notify.title': 'Tomato Pop 🍅',
    'streak.notify.keep.0':
        '🔥 Sua sequência de {count} dias conta com você. Um tomate a mantém viva!',
    'streak.notify.keep.1':
        'Não deixe a chama apagar! Encaixe uma sessão de foco e mantenha os {count} dias.',
    'streak.notify.keep.2':
        '🍅 Só 25 minutinhos separam você do dia {count}+. Você consegue!',
    'streak.notify.keep.3':
        'Seu tomate está esperando. Estoure um hoje e a sequência de {count} dias continua 🔥',
    'streak.notify.comeback.0':
        'Seu tomate sente sua falta 🍅 Volte para um recomeço.',
    'streak.notify.comeback.1':
        'Uma nova sequência começa com um único tomate. Quando quiser!',
    'streak.notify.comeback.2':
        'Psiu... seu tomate anda treinando a explosão. Venha ver 💥',
    'streak.notify.congrats.0':
        '🎉 {count} dias seguidos! Vamos manter o ritmo hoje.',
    'streak.notify.congrats.1':
        'Olha só, {count} dias firmes 🔥 Mais um tomate hoje?',
    'streak.notify.congrats.2':
        '🍅 Sequência de {count} dias! Você está pegando fogo. Continue!',
    'streak.notify.milestone':
        '🏆 {count} dias seguidos! Isso já é hábito. Venha comemorar com seu tomate!',
};
